import { c as _c } from "react/compiler-runtime";
import { Grid, TextField } from '@petsmart-ui/sparky';
import { useFormikContext } from 'formik';
import { getNextApiRoute, handleSetPhoneNumber } from '@libs/common-next';
import { CountryTarget } from '../../constants';
import { AddressForm } from '../AddressForm';
import { NameFields } from '../NameFields';
import type { PaymentFormInterface } from '../PaymentForm/types';
export function BillingAddressForm() {
  const $ = _c(18);
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue
  } = useFormikContext();
  let t0;
  if ($[0] !== errors || $[1] !== handleBlur || $[2] !== handleChange || $[3] !== touched || $[4] !== values) {
    t0 = <NameFields values={values} touched={touched} errors={errors} onBlur={handleBlur} onChange={handleChange} />;
    $[0] = errors;
    $[1] = handleBlur;
    $[2] = handleChange;
    $[3] = touched;
    $[4] = values;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Grid.Item><AddressForm countryTarget={CountryTarget.BOTH} addressSuggestionRoute={getNextApiRoute("address/suggest-address")} /></Grid.Item>;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== setFieldValue) {
    t2 = e => {
      handleSetPhoneNumber(e, setFieldValue);
    };
    $[7] = setFieldValue;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = touched.phone && !!errors.phone;
  const t4 = touched.phone && errors.phone?.[0];
  let t5;
  if ($[9] !== handleBlur || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== values.phone) {
    t5 = <Grid.Item><TextField data-cs-mask={true} data-testid="phone" id="phone" label="Phone number" name="phone" maxLength={14} type="tel" value={values.phone} onBlur={handleBlur} onChange={t2} isError={t3} fieldNote={t4} /></Grid.Item>;
    $[9] = handleBlur;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = values.phone;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t0 || $[16] !== t5) {
    t6 = <div className="billing-address-form" data-testid="billing-address-form"><Grid gap="sm">{t0}{t1}{t5}</Grid></div>;
    $[15] = t0;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}